import { Injectable } from '@angular/core';
import {
    BaseIndexedDbRepository,
    SynchronizationService
} from 'libs/arch/src/lib/repositories/indexed-db';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { MilkedAnimal } from './milked-animal';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MilkedAnimalRepository extends BaseIndexedDbRepository<MilkedAnimal, MilkedAnimal> {
    protected override readonly storeName: string = 'milkedAnimals';

    constructor(
        dbService: NgxIndexedDBService,
        synchronizationService: SynchronizationService
    ) {
        super(dbService, synchronizationService);

        this.registerAnimalReferences('animalId');
    }

    protected mapToEntity(dbItem: MilkedAnimal): MilkedAnimal {
        return MilkedAnimal.fromJson(dbItem);
    }

    protected override mapToSummary(item: MilkedAnimal): MilkedAnimal {
        return item;
    }

    protected override getSearchableFields(): string[] {
        return ['animal.name', 'animal.register', 'date', 'flaskNumber'];
    }

    protected override getResourcePath(): string {
        return 'milkedAnimals';
    }

    listByMilkingId(milkingId: string): Observable<MilkedAnimal[]> {
        return this.dbService
            .getAllByIndex<MilkedAnimal>(
                this.storeName,
                'milkingId',
                IDBKeyRange.only(milkingId)
            )
            .pipe(map((dbItems) => dbItems.map((item) => this.mapToEntity(item))));
    }

    listByControlId(controlId: string): Observable<MilkedAnimal[]> {
        return this.dbService
            .getAllByIndex<MilkedAnimal>(
                this.storeName,
                'milkControlId',
                IDBKeyRange.only(controlId)
            )
            .pipe(map((dbItems) => dbItems.map((item) => this.mapToEntity(item))));
    }

    findByMilkingId(milkingId: string): Observable<MilkedAnimal[]> {
        return this.dbService.getAllByIndex<any>(this.storeName, 'milkingId', milkingId)
            .pipe(
                map((dbItems) => {
                    if (!dbItems) return [];

                    if (Array.isArray(dbItems)) {
                        return dbItems.map((it) => this.mapToEntity(it));
                    }

                    return [this.mapToEntity(dbItems)];
                })
            );
    }
}
